import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CallActionOptionsList from './CallActionOptionsList';

const ConfigureSlotModal = ({ open, onClose, slot, route }) => {
  const applyAction = (actionType) => {
    slot(actionType);
    onClose();
  };

  return (
    <Dialog open={open} onClose={()=> onClose(false)} maxWidth="xs" fullWidth 
        BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.8)" },
      }}
      >
      <div className="px-4 pt-4 pb-1">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-900">
            Configure Slot
            
          </h2>
          <IconButton onClick={()=> onClose(false)} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      </div>

      <DialogContent className="pb-4">
        <CallActionOptionsList
          context="root"
          route={route}
          onSelect={applyAction}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ConfigureSlotModal;
